export default "__VITE_ASSET__CgeohOGf__"